import { createSelector } from "reselect";
import _, { _Chain } from "underscore";

import CloudFile from "../../../models/domain/cloud_file";
import getFilesById from "./get_files_by_id";
import getScanDatasetsForProjectByFirebaseId from "../scan_dataset_getters/get_scan_datasets_for_project_by_firebase_id";
import ScanDataset from "../../../models/domain/scan_dataset";

const emptyCloudFiles: CloudFile[] = [];

const getScanDatasetFilesForProjectByScanDatasetId = createSelector([
  getScanDatasetsForProjectByFirebaseId,
  getFilesById
], (scanDatasetsByFirebaseId, filesById) => {
  return (_.chain<ScanDataset, _.Dictionary<ScanDataset>>(scanDatasetsByFirebaseId)
    .mapObject(scan => scan?.files)
    .omit(_.isUndefined)
    .mapObject(Object.values) as _Chain<number[][], { [scanDatasetId: string]: number[][] }>)
    .mapObject(files => _.flatten(files))
    .reduce<{ [scanDatasetId: string]: CloudFile[] }>((filesSoFar, fileIds, scanDatasetId) => {
      if (fileIds.length) {
        filesSoFar[scanDatasetId] = [];
        fileIds.forEach((id) => {
          filesSoFar[scanDatasetId].push(filesById[id]);
        });
      } else {
        filesSoFar[scanDatasetId] = emptyCloudFiles;
      }
      return filesSoFar;
    }, {})
    .value();
});

export default getScanDatasetFilesForProjectByScanDatasetId;
